import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Banner() {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/banner").then((r) => setBanner(r.data)).catch(() => {});
    setDismissed(localStorage.getItem("loulou_banner_dismissed_v1") === "1");
  }, []);

  if (!banner || !banner.enabled || !banner.text || dismissed) return null;

  return (
    <div data-testid="landing-banner" className="sticky top-0 z-60 w-full bg-blue-600 text-white shadow-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-3 lg:px-12">
        <p className="flex-1 text-sm font-medium text-white">
          <span className="mr-3 rounded-full bg-white px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.24em] text-blue-600">
            Nouveau
          </span>
          {banner.text}
          {banner.cta_label && banner.cta_href && (
            <a
              href={banner.cta_href}
              className="ml-3 font-semibold underline underline-offset-4 hover:text-blue-100"
              data-testid="banner-cta"
            >
              {banner.cta_label} →
            </a>
          )}
        </p>
        <button
          data-testid="banner-dismiss"
          onClick={() => { localStorage.setItem("loulou_banner_dismissed_v1", "1"); setDismissed(true); }}
          className="text-white/80 transition-colors hover:text-white text-xl font-bold"
          aria-label="Fermer le bandeau"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
